import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';

class ChangePasswordForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    };
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkPasswordsMatch = this.checkPasswordsMatch.bind(this);
  }

  handleFieldChange = (event) => {
    switch (event.target.id) {
      case 'currentPassword': return (this.setState({ currentPassword: event.target.value }));
      case 'newPassword': return (this.setState({ newPassword: event.target.value }));
      case 'confirmPassword': return (this.setState({ confirmPassword: event.target.value }));
      default: return this.state;
    }
  }

  handleSubmit = (event) => {
    const { onSubmit } = this.props;

    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === true && this.checkPasswordsMatch()) {
      const body = (({
        currentPassword, newPassword,
      }) => ({
        currentPassword, newPassword,
      }))(this.state);
      onSubmit(body);
    }
    this.setState({ validated: true });
  }

  checkPasswordsMatch() {
    const { newPassword, confirmPassword } = this.state;
    const { onPasswordMismatch } = this.props;

    if (newPassword === confirmPassword) {
      return true;
    }

    onPasswordMismatch();
    return false;
  }

  render = () => {
    const {
      validated,
    } = this.state;

    const { formId } = this.props;

    return (
      <Form noValidate validated={validated} onSubmit={this.handleSubmit} id={formId}>
        <Form.Row>
          <Col>
            <Form.Group controlId="currentPassword">
              <Form.Label>Current Password</Form.Label>
              <Form.Control
                required
                type="password"
                onChange={this.handleFieldChange}
                placeholder="Enter the current password"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the current password.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="newPassword">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                required
                type="password"
                onChange={this.handleFieldChange}
                placeholder="Enter the new password"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the new password.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="confirmPassword">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                required
                type="password"
                onChange={this.handleFieldChange}
                placeholder="Confirm the new password"
              />
              <Form.Control.Feedback type="invalid">
                Please confirm the new password.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

ChangePasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onPasswordMismatch: PropTypes.func.isRequired,
  formId: PropTypes.string.isRequired,
};

export default ChangePasswordForm;
